module.exports = __webpack_public_path__ + "assets/img/discernment_id_card_describe.21420939.png";